import React from 'react';
import ProductCard from './ProductCard';
import productData from '../data/productData';
import './Products.css';


const Products = () => {
    const products = [
        {
            id: 'normal-vermicompost',
            ...productData['normal-vermicompost'],
            badge: { text: 'Best Seller', type: 'popular' }
        },
        {
            id: 'trichoderma-vermicompost',
            ...productData['trichoderma-vermicompost'],
            badge: { text: 'Disease Protection', type: 'disease-protection' }
        },
        {
            id: 'premium-vermicompost',
            ...productData['premium-vermicompost'],
            badge: { text: 'Premium Quality', type: 'premium' }
        },
        {
            id: 'coco-peat',
            ...productData['coco-peat'],
            badge: { text: 'Coming Soon', type: 'coming-soon' },
            comingSoon: true
        },
        {
            id: 'potting-mixture',
            ...productData['potting-mixture'],
            badge: { text: 'Balanced Mix', type: 'balanced' }
        },
        {
            id: 'vermiwash',
            ...productData['vermiwash'],
            badge: { text: 'Coming Soon', type: 'coming-soon' },
            comingSoon: true
        }
    ];

    return (
        <section id="products" className="products-section">

            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">Our Soil-Building Products</h2>
                    <p className="section-subtitle">
                        Compost and inputs made to restore life in soil
                    </p>
                </div>
                <div className="products-grid">
                    {products.map((product, index) => (
                        <ProductCard
                            key={product.id}
                            id={product.id}
                            title={product.title}
                            image={product.image}
                            description={product.shortDescription}
                            badge={product.badge}
                            index={index}
                            comingSoon={product.comingSoon}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Products;
